var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var l0 = !_vm.loading
    ? _vm.__map(_vm.listData, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var a0 = {
          startstamp: item.start_time,
          endstamp: item.end_time,
        }
        var g0 = (
          item.sku[0].product_price * 1 -
          item.sku[0].advance_price * 1
        ).toFixed(2)
        return {
          $orig: $orig,
          a0: a0,
          g0: g0,
        }
      })
    : null
  var g1 = !_vm.loading ? _vm.listData.length == 0 && !_vm.loading : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }